const state = {
  punch_btn_status: -1,
  fromid: -1,
  status: -1,
  valid_punch_times: -1,
};
const mutations = {
  punch_btn_status(state, punch_btn_status) {
    state.punch_btn_status = punch_btn_status;
  },
  fromid(state, fromid) {
    state.fromid = fromid;
  },
  status(state, status) {
    state.status = status;
  },
  valid_punch_times(state, valid_punch_times) {
    state.valid_punch_times = valid_punch_times;
  },
};
const actions = {
  apply_status: ({ commit }) => commit("apply_status"),
  fromid: ({ commit }) => commit("fromid"),
  status: ({ commit }) => commit("status"),
  valid_punch_times: ({ commit }) => commit("valid_punch_times"),
};
export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
